// extracted by mini-css-extract-plugin
export default {"layoutContainer":"CRMLayout_layoutContainer__Y1yRD","mainContent":"CRMLayout_mainContent__apbBX"};